export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": ["Organization", "MedicalOrganization"],
  "@id": "https://scienzahealth.com/#organization",
  "name": "Scienza Health",
  "alternateName": "Digital Human® AI Platform",
  "url": "https://scienzahealth.com",
  "logo": {
    "@type": "ImageObject",
    "url": "https://scienzahealth.com/mcai_logo_green.svg",
    "width": "400",
    "height": "400"
  },
  "description": "Transforming healthcare delivery with AI-powered Digital Human® for patient access automation, clinical support, and care optimization",
  "image": {
    "@type": "ImageObject",
    "url": "https://scienzahealth.com/images/scienza_social_preview.png",
    "width": "1200", 
    "height": "630"
  },
  "sameAs": [
    "https://twitter.com/scienzahealth",
    "https://linkedin.com/company/scienza-health"
  ],
  "brand": {
    "@type": "Brand",
    "name": "Digital Human® AI Platform"
  },
  "founder": {
    "@type": "Person",
    "name": "Scienza Health Leadership Team"
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "US",
    "addressLocality": "United States"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "url": "https://scienzahealth.com/contact",
      "availableLanguage": "English"
    },
    {
      "@type": "ContactPoint", 
      "contactType": "sales",
      "url": "https://scienzahealth.com/contact",
      "availableLanguage": "English"
    }
  ],
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  },
  "knowsAbout": [
    "Artificial Intelligence in Healthcare",
    "Digital Health Technology",
    "Patient Access Solutions",
    "Clinical Decision Support",
    "Cognitive Health Assessment"
  ],
  "potentialAction": [
    {
      "@type": "Action",
      "name": "Get Started",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://scienzahealth.com/sign-up",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      }
    },
    {
      "@type": "Action",
      "name": "Learn More",
      "target": {
        "@type": "EntryPoint", 
        "urlTemplate": "https://scienzahealth.com/solutions",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      }
    }
  ]
};